export const onSetLoaded = (state, action) => {
  state.isLoaded = action.payload;
};

export const onSetError = (state, action) => {
  state.data = [];
  if ('changedData' in state) state.changedData = [];
  state.Error = action.payload;
  state.isLoaded = true;
};


export const onSetLoadedCreate = (state, action) => {
  state.isLoadedCreate = action.payload;
};
export const onSetLoadedUpdate = (state, action) => {
  state.isLoadedUpdate = action.payload;
};
export const onSetLoadedDelete = (state, action) => {
  state.isLoadedDelete = action.payload;
};

export const onErrorCreate = (state, action) => {
  state.errorCreate = action.payload;
  if (state && 'isUploading' in state) {
    state.isUploading = false;
  }
  // state?.changedRecords = {};
};
export const onErrorUpdate = (state, action) => {
  state.errorUpdate = action.payload;
  if (state && 'isUploading' in state) {
    state.isUploading = false;
  }
};
export const onErrorDelete = (state, action) => {
  state.errorDelete = action.payload;
};
export const createFailed = (state, action) => {
  let message = action.payload.message;
  state.errorCreate = message;
  if (state && 'isUploading' in state) {
    state.isUploading = false;
  }
};
export const updateFailed = (state, action) => {
  let message = action.payload.message;
  state.errorUpdate = message;
  if (state && 'isUploading' in state) {
    state.isUploading = false;
  }
};
export const deleteFailed = (state, action) => {
  let message = action.payload.message;
  state.errorDelete = message;
};

export const onInitial = (state, action) => {
  state.data = action.payload;
  state.isLoaded = true;
  state.Error = null;
};
export const onClearStore = (state, action) => {
  state.data = [];
  state.isLoaded = false;
  state.Error = null;
};


// export const getDetailSuccess = (state, action) => {
//   let { key, data } = action.payload;
//   if (!state[key]) {
//     state[key] = {};
//     state.namekeys.push(key);
//     state[key].data = data;
//     state[key].isLoaded = true;
//   } else {
//     state[key] = {
//       data: data,
//       isLoaded: true
//     };
//   }
// }
// export const onSetDetailLoaded = (state, action) => {
//   let { key, isLoaded } = action.payload;
//   if (state.namekeys.includes(key)) {
//     state[key].isLoaded = isLoaded;
//   } else {
//     state[key] = {};
//     state.namekeys.push(key);
//     state[key].isLoaded = isLoaded;
//   }
// };

// export const onSetDetailError = (state, action) => {
//   state[action.payload.key].Error = action.payload.isError;
// };
